import styled from 'styled-components';

export const SearchResultTable = styled.table`
  width: 100%;
  tbody {
    min-height: 200px;
  }
  tr:nth-child(even) {
    background-color: #f2f2f2;
  }
  th {
    text-align: left;
  }
`;

export const NoSearchResultContainer = styled.div`
  height: 150px;
  line-height: 150px;
  font-weight: bolder;
  text-align: center;
  width: 100%;
`;

export const ClickableTr = styled.tr`
  cursor: pointer;
`;
